import { CwsAlert, CwsButton, CwsGridCol, CwsGridRow, CwsH4, CwsP } from '@components/cws'
import { OutOfStock } from '@components/product/ProductViewParameters/OutOfStock'
import { useTranslate } from '@hooks/useTranslation'
import type { Product } from '@model/product'
import React, { type FC } from 'react'

interface ComponentProps {
  isOpenCheckEmail: boolean
  product: Product
  setIsOpenCheckEmail: any
}

export const ProductViewParametersIsOutOfStock: FC<ComponentProps> = ({
  isOpenCheckEmail,
  product,
  setIsOpenCheckEmail,
}) => {
  const { translate } = useTranslate()

  return (
    <>
      {isOpenCheckEmail ? (
        <OutOfStock productId={product.id} />
      ) : (
        <>
          <CwsGridRow>
            <CwsGridCol col="12">
              <CwsGridRow justifyContent="center">
                <CwsGridCol col="auto">
                  <CwsAlert variant="inline" type="info">
                    <CwsP size="small">{translate('product.detail.product.disabled')}</CwsP>
                  </CwsAlert>
                </CwsGridCol>
              </CwsGridRow>
            </CwsGridCol>
            <CwsGridCol col="12">
              <CwsButton variant="secondary" onClick={() => setIsOpenCheckEmail(true)} width="fluid">
                {translate('product.details.subscribe.to.back.in.stock')}
              </CwsButton>
            </CwsGridCol>
          </CwsGridRow>
        </>
      )}
    </>
  )
}
